<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    title="请选择对应部门"
    width="50%"
    @closed="$emit('update:visible', false)">
    <el-tree
      ref="tree"
      :props="{
        label: 'organizationName',
        value: 'organizationId',
        children: 'children',
        multiple: true,
      }"
      :data="organizationOptions"
      show-checkbox
      @check-change="handleCheckChange">
    </el-tree>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)" size="small">取消</el-button>
      <el-button @click="handleSubmit" size="small">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryOrganizationTree } from '@/api/base';

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      organizationOptions: [],
      formQuery: {
        organizationId: [],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$emit('update', this.$refs.tree.getCheckedNodes().map((item) => item.organizationId));
      this.$emit('update:visible', false);
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },
    clearChildren(child) {
      child.forEach((item) => {
        if (!item.children.length) {
          // eslint-disable-next-line no-param-reassign
          delete item.children;
        } else {
          this.clearChildren(item.children);
        }
      });
      return child;
    },
    async getOrganizationTreeOptions() {
      try {
        const { data: { organizationTreeVos } } = await queryOrganizationTree();
        // console.log(str);
        this.organizationOptions = this.clearChildren(organizationTreeVos);
      } catch (error) {
        console.error(error);
      }
    },
  },
  // watch: {
  //   visible(value) {
  //     if (value) {
  //       // 请求数据
  //       this.getOrganizationTreeOptions();
  //     }
  //   },
  // },
  mounted() {
    this.getOrganizationTreeOptions();
  },
};
</script>
